import { gql } from "apollo-boost";

export const GET_ALLERGY_GROUP_BY_MOLECULES = gql`
  query getAllergyGroupByMolecules(
    $where: AllergyGroupByMoleculesWhereInput
    $relations: [String]
  ) {
    getAllergyGroupByMolecules(where: $where, relations: $relations) {
      id
      enabled
      molecule {
        id
        name
      }
    }
  }
`;